export default defineNuxtPlugin(() => {
  const { $i18n } = useNuxtApp();
  const config = useRuntimeConfig();

  // TODO: фейковая ошибка типов
  // @ts-expect-error: TS2345: Argument of type 'ru' | 'en' is not assignable to parameter of type 'ru'.
  $i18n.setLocale(config.public.locale);
});
